import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import ListItem from '../components/ListItem';
import { useMaterialList } from '../hooks';
import { ListLoading } from '../components/Loading';

const Container = styled.div`
  max-height: auto;
  overflow-y: auto;
  margin-top: 60px;
`;

const List = ({ localityId, onClick }) => {
  const { materials, error, loading } = useMaterialList(localityId);
  return (
    <Container>
      {
        loading && <ListLoading />
      }
      {
        !error
        && materials.length
          ? (
            <div>
              {
                materials.map((material, i) => (
                  <ListItem
                    letter={material.group}
                    materials={material.children}
                    onClick={onClick}
                    key={material.group}
                    tabIndex={i}
                  />
                ))
              }
            </div>
          ) : null
      }
    </Container>
  );
};

const mapStateToProps = (state) => ({
  localityId: state.app.localityId
});

export default connect(mapStateToProps)(List);
